import React from "react";
import { V2_ROUTES } from "../../state/useV2Navigation";
import { NAV_ITEMS } from "../../nav/navItems";
import { v2cx } from "../../theme/tokens";

/**
 * Soft gate when a desktop-only route is opened on a phone (deep link / stale URL).
 */
export default function DesktopOnlyGate({ routeKey, onNavigate }) {
  const item = NAV_ITEMS.find((i) => i.key === routeKey);
  const label = item?.label || "This feature";

  return (
    <section className="mx-auto flex max-w-md flex-col items-start gap-4 px-4 py-10">
      <h1 className="text-xl font-semibold tracking-tight text-slate-900">
        {label} is desktop-only
      </h1>
      <p className="text-sm leading-relaxed text-slate-600">
        Open DecisionPen on a larger screen to use {label.toLowerCase()}. On
        your phone, keep using Ask, Inbox, Map, and Approvals.
      </p>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onNavigate?.(V2_ROUTES.home)}
          className={v2cx(
            "rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-medium text-white",
            "active:bg-blue-700"
          )}
        >
          Go to Ask
        </button>
        <button
          type="button"
          onClick={() => onNavigate?.(V2_ROUTES.architectureGallery)}
          className={v2cx(
            "rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700",
            "active:bg-slate-50"
          )}
        >
          Open Map
        </button>
      </div>
    </section>
  );
}
